module.exports = __webpack_public_path__ + "img/13_24.212087d8.png";